import * as actionTypes from '../actions/allActionList';

const initialState = {
  chatRoomLocals: {
    fetchingStarted: false,
    subChatIndex: null /* value is number, index of sub chat array */,
    fetchingDone: false,
    mainChatActive: true,
  },
  io: null,
  chatUsersCredentials: null,
  onlineUsers: [],
  mainChatRoom: null,
  mainChatInfo: null,
  subChatRoom: [],
  unexpectedServerError: false,
  /* To prevent message spam while the other message is still being sent */
  sendingStarted: false,
  sendingDone: false,
  messageNotSentStatus: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FAILED_TO_CONNECT_ON_CHAT:
      return {
        ...state,
        io: null,
      };
    case actionTypes.SUCCESSFUL_CONNECT_TO_CHAT:
      return {
        ...state,
        io: action.io,
      };
    case actionTypes.SUCCESSFUL_GETTING_ALL_USER_CREDENTIALS:
      return {
        ...state,
        chatUsersCredentials: action.chatUsersCredentials,
      };
    case actionTypes.FAILED_GETTING_ALL_USER_CREDENTIALS:
      return {
        ...state,
        chatUsersCredentials: null,
        unexpectedServerError: true, // to be used to trigger a reload
      };
    case actionTypes.UPDATE_ONLINE_USERS_LIST:
      return {
        ...state,
        onlineUsers: action.onlineUsers,
      };
    case actionTypes.FAILED_GETTING_MAIN_CHAT:
      return {
        ...state,
        unexpectedServerError: true,
      };
    case actionTypes.SUCCESSFUL_GETTING_MAIN_CHAT:
      return {
        ...state,
        mainChatRoom: action.mainChatRoom,
        mainChatInfo: action.mainChatInfo,
      };
    case actionTypes.SUCCESSFUL_UPDATING_MAIN_CHAT:
      return {
        ...state,
        mainChatRoom: action.mainChatRoom,
      };
    case actionTypes.FAILED_UPDATING_MAIN_CHAT:
      return {
        ...state,
        unexpectedServerError: true,
        sendingStarted: false,
        sendingDone: true,
        messageNotSentStatus: null,
      };
    case actionTypes.CHANGE_SUB_CHAT_STATES:
      return {
        ...state,
        chatRoomLocals: {
          ...state.chatRoomLocals,
          fetchingStarted: false,
          fetchingDone: true,
          mainChatActive: false,
          subChatIndex: action.idx,
        },
      };
    case actionTypes.RECOVER_MAIN_CHAT_STATE:
      return {
        ...state,
        chatRoomLocals: {
          ...state.chatRoomLocals,
          fetchingStarted: false,
          fetchingDone: true,
          mainChatActive: true,
          subChatIndex: null,
        },
      };
    case actionTypes.STARTED_GETTING_SUB_CHAT:
      return {
        ...state,
        chatRoomLocals: {
          ...state.chatRoomLocals,
          fetchingStarted: true,
          mainChatActive: false,
          subChatIndex: action.idx,
        },
      };
    case actionTypes.FAILED_GETTING_SUB_CHAT:
      return {
        ...state,
        unexpectedServerError: true,
        chatRoomLocals: {
          ...state.chatRoomLocals,
          fetchingStarted: false,
          fetchingDone: true,
        },
      };
    case actionTypes.SUCCESSFUL_GETTING_SUB_CHAT:
      return {
        ...state,
        subChatRoom: [...state.subChatRoom, action.subChat],
        chatRoomLocals: {
          ...state.chatRoomLocals,
          fetchingStarted: false,
          fetchingDone: true,
          sendingStarted: false,
          sendingDone: true,
        },
      };
    case actionTypes.STARTED_SENDING_MESSAGE:
      return {
        ...state,
        sendingStarted: true,
        sendingDone: false,
        messageNotSentStatus: null,
      };
    case actionTypes.FINISHED_SENDING_MESSAGE:
      return {
        ...state,
        sendingStarted: false,
        sendingDone: true,
      };
    case actionTypes.MESSAGE_NOT_SENT:
      return {
        ...state,
        sendingStarted: false,
        sendingDone: true,
        messageNotSentStatus: `Error code: ${action.error.status}.`,
      };
    case actionTypes.CLEAR_NOT_SENT_STATUS:
      return {
        ...state,
        messageNotSentStatus: null,
      };
    case actionTypes.FAILED_UPDATING_SUB_CHAT:
      return {
        ...state,
        unexpectedServerError: true,
        sendingStarted: false,
        sendingDone: true,
        messageNotSentStatus: null,
      };
    case actionTypes.ON_LEAVE_CHAT_CMP:
      return {
        ...state,
        chatRoomLocals: {
          ...state.chatRoomLocals,
          fetchingStarted: false,
          subChatIndex: null,
          fetchingDone: false,
          mainChatActive: true,
        },
      };
    case actionTypes.SUCCESSFUL_UPDATING_SUB_CHAT:
      return {
        ...state,
        subChatRoom: action.subChat,
        messageNotSentStatus: null,
      };
    default:
      return state;
  }
};

export default reducer;
